import StatusList from "../packages/components/StatusList";

function Statuses() {
  return <StatusList />
}

export default Statuses;
